import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ListItemButton from '@mui/material/ListItemButton';
import Typography from '@mui/material/Typography';
import { useHttp } from 'hooks/use-fetch';
import useConfirm from 'hooks/use-confirm';
import NavTree from 'utils/NavTree';
import { NavTreeIds } from 'types/NavTreeModel';
import { Box } from '@mui/material';
import Theme from 'theme';

export default function InlineNavItems() {
  const navigate = useNavigate();
  const location = useLocation();

  const { hasUnsavedChanges, userRoles, isBillingAdmin } = useHttp();
  const { showConfirm, ConfirmDialog } = useConfirm();

  const filteredNavItems = React.useMemo(() => NavTree.filter(
    (navItem) => {
      const hasRoles = navItem.roles.some((role) => userRoles[role]);
      return navItem.id === NavTreeIds.REPORTS ? isBillingAdmin || hasRoles : hasRoles;
    },
  ), [userRoles, isBillingAdmin]);

  const handleClick = (to: string) => {
    if (hasUnsavedChanges) {
      showConfirm({
        message: 'Are you sure you want to navigate away?',
        onConfirm: () => navigate(to),
      });
    }
    else {
      navigate(to);
    }
  };
  return (
    <>
      <ConfirmDialog />
      {filteredNavItems.map((navItem) => {
        const isActive = location.pathname.startsWith(navItem.spaUrl);
        return (
          <ListItemButton
            key={navItem.id}
            onClick={() => handleClick(navItem.spaUrl)}
            sx={{
              p: 0,
              minWidth: 'auto',
              color: isActive ? Theme.custom.darkTextPrimary
                : Theme.custom.colors.lightTextSecondary,
              borderRadius: 0,
              '&:hover': {
                backgroundColor: 'transparent',
                color: Theme.custom.colors.darkTextPrimary,
              },
              flex: 0,
            }}
          >
            <Box
              sx={{
                borderBottom: isActive ? '2px solid #33739D' : '2px solid transparent',
                display: 'inline-block',
                lineHeight: 1.5,
                px: 1,
              }}
            >
              <Typography
                variant='h6'
                fontWeight={500}
                noWrap
              >
                {navItem.name}
              </Typography>
            </Box>
          </ListItemButton>
        );
      })}
    </>
  );
}
